import axios from "axios";
import TokenService from "../auth/TokenService";
import { BASE_URL_HERES_AMERICA } from "../../config";
export const heresAmericaapi = axios.create({
  baseURL: BASE_URL_HERES_AMERICA,
  headers: {
    "Content-Type": "application/json",
  },
});
export const heresAmericaAuthApi = axios.create({
  baseURL: BASE_URL_HERES_AMERICA,
  headers: {
    "Content-Type": "application/json",
  },
});
class HeresAmericaService {
  async revalidateProjectBooks(seriesSlug, bookSlug) {
    try {
      const seriesRes = await heresAmericaAuthApi.get(
        `/revalidate?path=/profile/series/${seriesSlug}&secret=Snapple`
      );
      if (bookSlug) {
        await heresAmericaAuthApi.get(
          `/revalidate?path=/profile/book/${bookSlug}&secret=Snapple`
        );
      }
      return seriesRes;
    } catch (err) {
      throw err;
    }
  }

  async submitBookImageDataToHA(bookData) {
    try {
      const res = await heresAmericaAuthApi.put(
        `/books/${bookData.externalBookId}`,
        bookData
      );
      return res;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }

  // BOOK ENDPOINTS
  async getBooks() {
    try {
      const res = await heresAmericaAuthApi.get("/books");
      return res;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async getBook(id) {
    try {
      const res = await heresAmericaAuthApi.get(`/books/identifier/${id}`);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }

  async updateBook(formData, id) {
    formData.bookId = id;
    try {
      const res = await heresAmericaAuthApi.patch(`/books/${id}`, formData);

      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async deleteBook(id) {
    try {
      const res = await heresAmericaAuthApi.delete(`/books/${id}`);
      console.log(res);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  //AGE GROUP
  async getAllAgeGroups() {
    try {
      const res = await heresAmericaAuthApi.get(`/ageGroup`);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  /// SERIES CRUD ENDPOINTS
  async getAllSeries({ page = 1, pageSize = 100 } = {}) {
    try {
      const res = await heresAmericaAuthApi.get(
        `/series?page=${page}&pageSize=${pageSize}`
      );
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async updateSeries(seriesData) {
    try {
      const res = await heresAmericaAuthApi.put(
        `/series/${seriesData.slug}`,
        seriesData
      );
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async deleteSeries(slug) {
    try {
      console.log(slug);
      const res = await heresAmericaAuthApi.delete(`/series/${slug}`);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async createSeries(seriesData) {
    try {
      const res = await heresAmericaAuthApi.post(`/series`, seriesData);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  async uploadMediaForQuiz(formData) {
    try {
      const res = await heresAmericaAuthApi.post(`upload`, formData);
      return res.data;
    } catch (error) {
      throw error; // Rethrow the error to handle it outside
    }
  }
  /// Tag Crud Operations

  async createTag(name) {
    try {
      const res = await heresAmericaAuthApi.post(`/tag`, { name });
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async createBook(formData) {
    try {
      const res = await heresAmericaAuthApi.post(`/books/0`, formData);
      console.log(res);
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async getTagById(id) {
    try {
      const res = await heresAmericaAuthApi.get(`/tag/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async getAllTags() {
    try {
      const res = await heresAmericaAuthApi.get(`/tag`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async updateTag(id, name) {
    try {
      const res = await heresAmericaAuthApi.put(`/tag/${id}`, { name });

      console.log({ name });
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteTag(id, name) {
    try {
      const res = await heresAmericaAuthApi.delete(`/tag/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async createOrUpdateQuiz(externalBookId, data) {
    try {
      const res = await heresAmericaAuthApi.post(
        `/quiz/${externalBookId}`,
        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  // quiz object model for updateQuiz from ha backend   const { title, externalBookId, titleAudio, timeLimit, randomization, feedbackTiming, quizType,isOpenBook } = req.body;

  async updateQuiz(externalBookId, quizId, data) {
    try {
      const res = await heresAmericaAuthApi.put(
        `/quiz/${externalBookId}?quizId=${quizId}`,

        data
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async getQuizById(externalBookId, quizId) {
    try {
      const res = await heresAmericaAuthApi.get(
        `/quiz/${externalBookId}?quizId=${quizId}`
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteQuizById(externalBookId, quizId) {
    try {
      const res = await heresAmericaAuthApi.delete(
        `/quiz/${externalBookId}?quizId=${quizId}`
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }
  // Answer Model
  ///  id             Int              @id @default(autoincrement())
  // text           Json // Changed to Json to account for localized text
  // isCorrect      Boolean
  // questionId     Int
  ///

  async updateAnswerById(answerId, answer) {
    try {
      const res = await heresAmericaAuthApi.put(
        `/quiz/answer/${answerId}`,
        answer
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async getAnswerById(answerId, answer) {
    console.log(answerId, answer);
    try {
      const res = await heresAmericaAuthApi.get(
        `/quiz/answer/${answerId}`,
        answer
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteAnswerById(answerId) {
    try {
      const res = await heresAmericaAuthApi.delete(`/quiz/answer/${answerId}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async createAnswer({ questionId, text, isCorrect }) {
    try {
      const res = await heresAmericaAuthApi.post(`/quiz/answer`, {
        questionId,
        text,
        isCorrect,
      });

      return res.data;
    } catch (error) {
      throw error;
    }
  }

  //question object
  // { text, quizId, type, feedback, attemptsAllowed }
  async createQuestion(question) {
    try {
      const res = await heresAmericaAuthApi.post(`/quiz/question`, question);

      return res.data;
    } catch (error) {
      throw error;
    }
  }
  //question object
  // { text, quizId, type, feedback, attemptsAllowed }
  async updateQuestion(
    questionId,
    { text, quizId, type, feedback, attemptsAllowed, media }
  ) {
    try {
      const res = await heresAmericaAuthApi.put(
        `/quiz/question/${questionId}`,
        {
          text,
          quizId,
          type,
          feedback,
          attemptsAllowed,
          media,
        }
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteQuestion(questionId) {
    try {
      const res = await heresAmericaAuthApi.delete(
        `/quiz/question/${questionId}`
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
  async translateText(text, targetLanguage) {
    const response = await heresAmericaAuthApi.post(
      "/upload/translate",

      { text, targetLanguage }
    );

    return response.data.translation;
  }
}

export default new HeresAmericaService();

heresAmericaAuthApi.interceptors.request.use(
  async (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
